import { render } from "./ProviderCard.vue?vue&type=template&id=1bf7164f"
import script from "./ProviderCard.vue?vue&type=script&lang=js"
export * from "./ProviderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__